import { shuffleArray } from './_shuffleArray';
import { hoverDynamic } from './hover';

export function chat() {
  const container = document.querySelector('.container');
  const chatContainer = document.querySelector('.chat-container');
  if(chatContainer && qa.list.length) {
    const typingIndicator = chatContainer.querySelector('.chat-typing-indicator');
    const chatControl = chatContainer.querySelector('.chat-control');
    const minDelay = 2000;   
    const maxDelay = 5000;
    const waitingTime = 1500;
    const shuffledQA = shuffleArray(qa.list);
    const linkIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>`;
    let questionIndex = 0;
    let currentStep = 0;
    let typingTimeout = null;

    function isPlaying() {
      return document.documentElement.classList.contains('is-chat-playing')
    }

    function pauseChat() {
      document.documentElement.classList.remove('is-chat-playing');
      hideTypingIndicator();
    }

    function playChat() {
      document.documentElement.classList.add('is-chat-playing');
    }

    function getRandomDelay() {
      return Math.random() * (maxDelay - minDelay) + minDelay;
    }

    function createElement(tag, className, text = null) {
      const element = document.createElement(tag);
      if (className) {
        if (Array.isArray(className)) {
          element.classList.add(...className);
        } else {
          element.classList.add(className);
        }
      }
      if (text !== null) {
        element.textContent = text;
      }
      return element;
    }

    function scrollToLatestMessage(msg) {
      if (chatContainer) {
        const msgRect = msg.getBoundingClientRect();
        const containerRect = chatContainer.getBoundingClientRect();
        if (msgRect.bottom > containerRect.bottom) {
          const scrollTo = chatContainer.scrollTop + (msgRect.bottom - containerRect.bottom);
          const startPosition = chatContainer.scrollTop;
          const distance = scrollTo - startPosition;
          const duration = 300;
          let startTime = null;
          function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 2);
            chatContainer.scrollTop = startPosition + distance * easeOut;
            if (timeElapsed < duration) {
              requestAnimationFrame(animation);
            }
          }
          requestAnimationFrame(animation);
        }
      }
    }

    function appendQuestion(question) {
      const msg = createElement('div', 'chat-question');
      const content = createElement('div', 'bubble-content');
      const bubble = createElement('div', ['bubble', 'lh1_5'], question);
      content.appendChild(bubble);
      msg.appendChild(content);
      chatContainer.appendChild(msg);
      scrollToLatestMessage(msg);
    }

    function appendAnswer(answer, url) {
      const msg = createElement('div', 'chat-answer');
      const content = createElement('div', 'bubble-content');
      let bubble = createElement('div', ['bubble', 'lh1_5'], answer);
      if(url) {
        bubble = createElement('a', ['bubble', 'lh1_5'], answer);
        bubble.href = url;
        bubble.innerHTML += linkIcon;
        hoverDynamic(bubble);
      }
      content.appendChild(bubble);
      msg.appendChild(content);
      chatContainer.appendChild(msg);
      scrollToLatestMessage(msg);
    }

    async function showTypingIndicatorAfterDelay() {
      typingTimeout = setTimeout(() => {
        if (isPlaying() && typingIndicator) {
          document.documentElement.classList.remove('is-chat-indicator-hidden');
        }
      }, waitingTime);
    }

    function hideTypingIndicator() {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
        typingTimeout = null;
      }
      if(typingIndicator) document.documentElement.classList.add('is-chat-indicator-hidden');
    }

    async function displayNext() {
      const item = shuffledQA[questionIndex];
      
      if (currentStep === 0) {
        await showNextMessage(() => appendQuestion(item.question));
        if (!isPlaying()) return;
        currentStep = 1;
      }
      
      if (currentStep === 1) {
        await showNextMessage(() => appendAnswer(item.answer, item.url));
        if (!isPlaying()) return;
        currentStep = 2;
      }

      if (currentStep === 2) {
        questionIndex = (questionIndex + 1) % shuffledQA.length;
        currentStep = 0;
      }

      if (isPlaying()) {
        displayNext();
      }
    }

    async function showNextMessage(displayFunc) {
      const delay = getRandomDelay();
      await showTypingIndicatorAfterDelay();
      await new Promise(res => {
        let waited = 0;
        const checkInterval = 100;
        const interval = setInterval(() => {
          if (!isPlaying()) {
            hideTypingIndicator();
            return;
          }
          waited += checkInterval;
          if (waited >= delay) {
            clearInterval(interval);
            res();
          }
        }, checkInterval);
      });
      
      hideTypingIndicator();
      displayFunc();
    }

    if(chatControl) {
      chatControl.addEventListener('click', () => {
        if (isPlaying()) {
          pauseChat();
        } else {
          playChat();
        }
      });
    }

    if(window.innerWidth <= 1024) {
      if(!document.documentElement.classList.contains('is-home-index-active')) {
        playChat();
      }
    } else {
      playChat();
    }

    displayNext();
  }
}
